app.base = {};

app.base.attachmentHelper = require('./components/base/AttachmentHelper.vue').default;
app.base.messageListBase = require('./components/base/MessageListBase.vue').default;
app.base.formSubmissionBase = require('./components/forms/FormSubmissionBase.vue').default;


var threadList = require('./components/generic/GenericList.vue').default;
var patientThreadList = require('./components/generic/PatientGenericList.vue').default;
var threadShow = require('./components/patient/MessageList.vue').default;
var threadListInner = require('./components/thread/ThreadList.vue').default;

var intro = require('./components/patient/Intro.vue').default;
var proxySelectAction = require('./components/patient/ProxySelectAction.vue').default;
var selectAction = require('./components/patient/SelectAction.vue').default;
var register = require('./components/patient/Register.vue').default;
var selfHelp = require('./components/patient/SelfHelp.vue').default;
// var isabel = require('./components/patient/Isabel.vue').default;
var formSubmission = require('./components/forms/FormSubmissionPatient.vue').default;
var loginType = require('./components/patient/LoginType.vue').default;
var loginForm = require('./components/generic/auth/Login.vue').default;
var logout = require('./components/patient/Logout.vue').default;
var forgottenPasswordForm = require('./components/patient/ForgottenPassword.vue').default;
var createPassword = require('./components/patient/CreatePassword.vue').default;
var profile = require('./components/patient/Profile.vue').default;
var profileDetails = require('./components/patient/ProfileDetails.vue').default;
var profileEdit = require('./components/patient/ProfileEdit.vue').default;
var info = require('./components/patient/Info.vue').default;
var accessType = require('./components/patient/AccessType.vue').default;
var registerPatient = require('./components/patient/RegisterPatient.vue').default;
var registerProxy = require('./components/patient/RegisterProxy.vue').default;
var selectCaree = require('./components/patient/SelectCaree.vue').default;
var staffAvailability = require('./components/patient/StaffAvailability.vue').default;
var serviceTimes = require('./components/patient/ServiceTimes.vue').default;
var booking = require('./components/bookings/patient/Booking.vue').default;
var campaign = require('./components/campaigns/patient/Campaign.vue').default;

var oauth = require('./components/patient/OAuth.vue').default;
var terms = require('./components/patient/Terms.vue').default;

var error404 = require('./components/patient/Error404.vue').default;

var appLoading = require('./components/patient/AppLoading.vue').default;

var routes = [{
        path: '/thread-list/:archive?',
        name: 'threadList',
        components: {
            content1: patientThreadList
        },
        props: {
            content1: {
                modalid: "thread-filter-modal",
                displayelement: "thread-list",
                event: "thread",
                model: "thread",
                title: "translations.requests_title",
                path: 'threads',
                route: '/api/vp1/threads',
                subroute: 0,
                hasarchive: 1,
            }
        },
        meta: {
            title: 'translations.requests_title'
        }
    },
    {
        path: '/thread-show/:id/:archive?',
        name: 'threadShow',
        components: {
            content1: threadShow
        },
        props: {
            content1: {
                type: "edit",
                event: "message",
                model: "message",
                elementname: "Messages",
                apiRoute: '/api/vp1'
            }
        },
        meta: {
            title: 'translations.messages_thread'
        }
    },
    {
        path: '/thread-create/:user_id?',
        name: 'threadCreate',
        components: {
            content1: threadShow
        },
        props: {
            content1: {
                type: "create",
                event: "message",
                model: "message",
                elementname: "Messages",
                apiRoute: '/api/vp1'
            }
        },
        meta: {
            title: 'translations.messages'
        }
    },
    {
        path: '/',
        name: 'appLoading',
        components: {
            content1: appLoading
        },
        props: {
            content1: {

            }
        },
        meta: {
            title: 'translations.introduction'
        }
    },
    {
        path: '/accessType/:action?/:action_id?',
        name: 'accessType',
        components: {
            content1: accessType
        },
    },
    {
        path: '/intro',
        name: 'intro',
        components: {
            content1: intro
        },
        props: {
            content1: {

            }
        },
        meta: {
            title: 'translations.welcome_to_askmyGP'
        }
    },
    {
        path: '/proxy-select-action/:user_id',
        name: 'proxySelectAction',
        components: {
            content1: proxySelectAction
        },
        props: {
            content1: {

            }
        },
        meta: {
            title: 'translations.select_service'
        }
    },
    {
        path: '/select-action/:user_id',
        name: 'selectAction',
        components: {
            content1: selectAction
        },
        props: {
            content1: {

            }
        },
        meta: {
            title: 'translations.select_service'
        }
    },
    {
        path: '/self-help/:user_id?',
        name: 'selfHelp',
        components: {
            content1: selfHelp
        },
        meta: {
            title: 'translations.self_help'
        }
    },
    // {
    //     path: '/isabel',
    //     name: 'isabel',
    //     components: {
    //         content1: isabel
    //     },
    //     meta: {
    //         title: 'Isabel'
    //     }
    // },
    {
        path: '/form-submission/:id/:archive?',
        name: 'formSubmission',
        components: {
            content1: formSubmission
        },
        meta: {
            title: 'translations.form'
        }
    },
    {
        path: '/login-type',
        name: 'loginType',
        components: {
            content1: loginType
        },

    },
    {
        path: '/login/:next?/:message?',
        name: 'loginForm',
        components: {
            content1: loginForm
        },
        meta: {
            title: 'translations.login'
        }
    },
    {
        path: '/logout',
        name: 'logout',
        components: {
            content1: logout
        },
    },
    {
        path: '/password-reset/:next?/:token?/:email?/:new?',
        name: 'forgottenPasswordForm',
        components: {
            content1: forgottenPasswordForm
        },
        meta: {
            title: 'translations.forgotten_password'
        },
        props: {
            content1: {
                linked_account_message: "translations.linked_account_password_information_unknown",
            }
        }
    },
    {
        path: '/profileDetails',
        name: 'ProfileDetails',
        components: {
            content1: profileDetails
        },
        meta: {
            title: 'translations.profile_details'
        }
    },
    {
        path: '/profileEdit',
        name: 'ProfileEdit',
        components: {
            content1: profileEdit
        },
        meta: {
            title: "translations.profile_edit"
        }

    },
    {
        path: '/profile',
        name: 'Profile',
        components: {
            content1: profile
        },
        meta: {
            title: 'translations.profile'
        }
    },
    {
        path: '/register',
        name: 'Register',
        components: {
            content1: register
        },
        meta: {
            title: 'translations.register'
        }
    },
    {
        path: '/registerPatient/:action?',
        name: 'RegisterPatient',
        components: {
            content1: registerPatient
        },
        meta: {
            title: 'translations.register_patient'
        }
    },
    {
        path: '/registerProxy/:action?/:action_id?',
        name: 'RegisterProxy',
        components: {
            content1: registerProxy
        },
        meta: {
            title: 'translations.register_proxy'
        }
    },
    {
        path: '/selectCaree/:action?/:action_id?',
        name: 'SelectCaree',
        components: {
            content1: selectCaree
        },
        meta: {
            title: 'translations.select_caree'
        }
    },
    {
        path: '/info',
        name: 'Info',
        components: {
            content1: info
        },
    },
    {
        path: '/staffAvailability',
        name: 'staffAvailability',
        components: {
            content1: staffAvailability
        },
        props: {
            content1: {

            }
        },
        meta: {
            title: 'translations.staff_availability'
        }
    },
    {
        path: '/serviceTimes',
        name: 'serviceTimes',
        components: {
            content1: serviceTimes
        },
        props: {
            content1: {

            }
        },
        meta: {
            title: 'translations.service_times'
        }
    },
    {
        path: '/booking/:id',
        name: 'booking',
        components: {
            content1: booking
        },
        props: {
            content1: {

            }
        },
        meta: {
            title: 'translations.appointment_booking'
        }
    },
    {
        path: '/campaign/:campaign_id/:user_id/:token?',
        name: 'campaign',
        components: {
            content1: campaign
        },
        props: {
            content1: {

            }
        },
        meta: {
            title: 'translations.campaign'
        }
    },
    {
        path: '/campaign-new-user/:campaign_id/:user_id/:token?',
        name: 'createPassword',
        components: {
            content1: createPassword
        },
        props: {
            content1: {

            }
        },
        meta: {
            title: 'translations.create_password'
        }
    },
    {
        path: '/oauth/authorize',
        name: 'oauth',
        components: {
            content1: oauth
        },
        meta: {
            title: 'translations.oauth'
        }
    },
    {
        path: '/terms/:next?',
        name: 'terms',
        components: {
            content1: terms
        },
        meta: {
            title: 'translations.terms'
        }
    },

    {
        path: '*',
        name: '404',
        components: {
            content1: error404
        }
    }
];

export default routes